import { Card } from '@payaca/ambrosia';
import { FC, PropsWithChildren, ReactNode, type JSX } from 'react';

import PayacaLogo from '@/assets/images/logo--payaca.svg?react';

import PageWrapper from '../pageWrapper/PageWrapper';

import './UnauthenticatedPageWrapper.sass';

type Props = {
  className?: string;
  headerContent?: ReactNode;
  titleContent?: ReactNode;
  footerContent?: ReactNode;
  hideBody?: boolean;
};
const UnauthenticatedPageWrapper: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  footerContent,
  headerContent,
  hideBody = false,
  titleContent,
}: PropsWithChildren<Props>): JSX.Element => {
  return (
    <PageWrapper
      className={`unauthenticated-page-wrapper ${className ? className : ''}`}
    >
      <div className={`header-content${hideBody ? ' no-body' : ''}`}>
        <PayacaLogo className="payaca-logo" role="img" aria-label="Payaca" />
      </div>
      {headerContent}
      {!hideBody && (
        <Card className="body-content">
          <Card.Body>
            {titleContent && (
              <div className="body-title-content">{titleContent}</div>
            )}
            {children}
          </Card.Body>
        </Card>
      )}
      <div className="footer-content">{footerContent}</div>
    </PageWrapper>
  );
};

export default UnauthenticatedPageWrapper;
